import { useState } from 'react';
import { fNumber } from '../../../../utils/helpers';
import { carDetails, general } from '../../../pages/fleet-calculator/copy';
import Modal from '../../ui/Modal';
import SecondaryButton from '../../ui/SecondaryButton';
import { useCarStoreContext } from '../store/car-store-provider';
import useSettingsStore from '../store/settings-store';
import { yearlyToMonthlyCost } from '../utils/calc';
import { getBensinForbrukningPrice, getElForbrukningPrice } from '../utils/car';

export default function CarDetails() {
  const detailedCarViewData = useCarStoreContext(
    (state) => state.detailedCarViewData,
  );
  const closeCarDetailsModal = useCarStoreContext(
    (state) => state.closeCarDetailsModal,
  );

  const { percentOnElectricity } = useSettingsStore();

  const [electricPercent, setElectricPercent] = useState(
    percentOnElectricity * 100,
  );
  if (!detailedCarViewData) return;

  const { car, calc } = detailedCarViewData;

  return (
    <Modal clickOutside={() => closeCarDetailsModal()}>
      <div className="bg-white shadow-lg max-w-[90dvw] w-[600px] p-6 flex flex-col gap-2">
        <h3 className="text-2xl font-semibold mb-4 max-w-[90%]">
          {carDetails.title} {car.name}
        </h3>
        <div className="grid md:grid-cols-2 text-sm gap-4">
          <div className="flex justify-between">
            <p>{carDetails.price}</p>
            <p>{fNumber(car.price)}</p>
          </div>
          <div className="flex flex-col gap-2">
            <p className="text-lg font-semibold">{carDetails.usageTitle}¹⁷⁾</p>
            <div className="flex justify-between">
              <p>{carDetails.usageFuel}</p>
              <p>
                {car.type?.name.toLowerCase() !== 'el'
                  ? getBensinForbrukningPrice(car.fuel_consumption)
                  : 0}{' '}
                liter/mil
              </p>
            </div>
            <div className="flex justify-between">
              <p>CO2-utsläpp</p>
              <p>{car.emissions ?? 0} g/km</p>
            </div>
            <div className="flex justify-between">
              <p>{carDetails.usageElectric}</p>
              <p>
                {car.electric_consumption
                  ? getElForbrukningPrice(car.electric_consumption)
                  : 0}{' '}
                kWh/100km
              </p>
            </div>
            {car.type?.name.toLowerCase() === 'laddhybrid' ? (
              <>
                <label
                  htmlFor="electricDrive"
                  className="flex justify-between mt-2"
                >
                  <p>{carDetails.totalElectic}</p>
                  <p>{electricPercent} procent</p>
                </label>
                <input
                  name="electricDrive"
                  id="electricDrive"
                  type="range"
                  value={electricPercent}
                  min={0}
                  max={100}
                  onChange={(e) => setElectricPercent(Number(e.target.value))}
                />
              </>
            ) : null}
            <div className="flex justify-between">
              <p>{carDetails.costFuel}</p>
              <p>
                {fNumber(yearlyToMonthlyCost(calc.fuelCost))}
                /mån
              </p>
            </div>
          </div>
        </div>

        <SecondaryButton
          className="mt-2"
          onClick={() => closeCarDetailsModal()}
        >
          {general.close}
        </SecondaryButton>
      </div>
    </Modal>
  );
}
